<template>
  <div class="page">
    <main>
      <!-- Hero Section -->
      <section class="hero">
        <div class="container">
          <h1 class="title">
            出海营销一站式视频<br />本地化解决方案
          </h1>
          <p class="subtitle">
            KisiAI 提供视频翻译、模特换脸、音色克隆、字幕擦除等 AI 技术，快速完成本地化营销视频生成。
          </p>
          <div class="heroButtons">
            <button class="primaryButton" @click="handleStart">开始使用</button>
            <div class="advisorButton-wrapper">
              <button class="advisorButton">联系产品顾问</button>
              <div class="qrcode-popup">
                <img :src="require('@/assets/images/service.jpg')" alt="联系我们" width="200" height="200" />
                <p>扫码添加产品顾问微信</p>
              </div>
            </div>
          </div>
          <div class="heroImage">
            <video autoplay loop muted playsinline>
              <source src="https://video.kisiai.com/videos/home.mp4" type="video/mp4">
              您的浏览器不支持视频播放
            </video>
          </div>
        </div>
      </section>

      <!-- Brand Logos -->
      <section class="brands">
        <div class="container">
        <div class="brandScroll">
          <div class="brandGrid">
            <img :src="require('@/assets/images/brands/vivavideo.CAebJYch.png')" alt="vivavideo" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Transsion.Dd5PSbkC.png')" alt="Transsion" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Haier.CKljEmGF.png')" alt="海尔" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Tiktok.lyeroEER.png')" alt="Tiktok" width="120" height="40" />
            <img :src="require('@/assets/images/brands/insta360.C1QBOoVs.png')" alt="Insta360" width="120" height="40" />
            <img :src="require('@/assets/images/brands/honer.BxB8Dmvg.png')" alt="honer" width="120" height="40" />
            <img :src="require('@/assets/images/brands/florasis.DBoXQo-H.png')" alt="florasis" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Anker.BsKU2XuT.png')" alt="Anker" width="120" height="40" />
            <img :src="require('@/assets/images/brands/dji.D8DfoR-4.png')" alt="dji" width="120" height="40" />
            <img :src="require('@/assets/images/brands/xiaomi.CKoGq_Ft.png')" alt="xiaomi" width="120" height="40" />
          </div>
          <div class="brandGrid">
            <img :src="require('@/assets/images/brands/vivavideo.CAebJYch.png')" alt="vivavideo" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Transsion.Dd5PSbkC.png')" alt="Transsion" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Haier.CKljEmGF.png')" alt="海尔" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Tiktok.lyeroEER.png')" alt="Tiktok" width="120" height="40" />
            <img :src="require('@/assets/images/brands/insta360.C1QBOoVs.png')" alt="Insta360" width="120" height="40" />
            <img :src="require('@/assets/images/brands/honer.BxB8Dmvg.png')" alt="honer" width="120" height="40" />
            <img :src="require('@/assets/images/brands/florasis.DBoXQo-H.png')" alt="florasis" width="120" height="40" />
            <img :src="require('@/assets/images/brands/Anker.BsKU2XuT.png')" alt="Anker" width="120" height="40" />
            <img :src="require('@/assets/images/brands/dji.D8DfoR-4.png')" alt="dji" width="120" height="40" />
            <img :src="require('@/assets/images/brands/xiaomi.CKoGq_Ft.png')" alt="xiaomi" width="120" height="40" />
          </div>
          </div>
        </div>
      </section>

      <!-- Features Section -->
      <section class="features">

        <div class="container">
          <h2 class="sectionTitle">
            让内容在全球范围内迅速传播增长
          </h2>
          <div class="featureGrid">
            <div class="featureCard">
              <div class="featureImage">
                <img
                  :src="require('@/assets/images/features/home_card_1.webp')"
                  alt="视频翻译"
                  width="300"
                  height="300"
                />
              </div>
              <div class="featureContent">
                <h2>中文素材批量生成<br />多语种视频广告</h2>
                <p>快速生成多语言营销视频，覆盖全球市场</p>
                <button class="primaryButton" @click="handleStart">开始使用</button>
              </div>
            </div>

            <div class="featureCard reverse">
              <div class="featureImage">
                <img 
                  :src="require('@/assets/images/features/home_card_2.webp')"
                  alt="全球内容平台" 
                  width="500" 
                  height="300"
                />
              </div>
              <div class="featureContent">
                <h2>将你的爆款视频<br />推广到全球内容平台</h2>
                <p>一键发布到各大主流平台，扩大品牌影响力</p>
                <button class="primaryButton" @click="handleStart">开始使用</button>
              </div>
            </div>

            <div class="featureCard">
              <div class="featureImage">
                <img 
                  :src="require('@/assets/images/features/home_card_3.webp')"
                  alt="本地化" 
                  width="300" 
                  height="300"
                />
              </div>
              <div class="featureContent">
                <h2>短视频本地化<br />登陆海外市场</h2>
                <p>专业的本地化处理，让内容更具市场竞争力</p>
                <button class="primaryButton" @click="handleStart">开始使用</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Testimonials Section -->
      <section class="testimonials">
        <div class="container">
          <h2 class="sectionTitle">深受合作客户信赖</h2>
          <div class="testimonialGrid">
            <div class="testimonialCard">
              <div class="stars">★★★★★</div>
              <h3>"效果非常自然"</h3>
              <p>我对这款AI软件的视频换脸功能印象深刻，它不仅能够精确捕捉面部表情，还能够无缝融合到视频中，效果非常自然。</p>
              <div class="reviewer">
                <img :src="require('@/assets/images/avatars/avatar-03.Bd1VePLx.jpg')" alt="跨境电商运营者" />
                <div class="reviewerInfo">
                  <strong>跨境电商运营者</strong>
                </div>
              </div>
            </div>

            <div class="testimonialCard">
              <div class="stars">★★★★★</div>
              <h3>"内容展示充分"</h3>
              <p>不仅提升了我们内容的吸引力，还通过高效的制作流程，提升了我们批量化制作视频的效率。</p>
              <div class="reviewer">
                <img :src="require('@/assets/images/avatars/avatar-04.DHchhNLz.jpg')" alt="内容营销经理" />
                <div class="reviewerInfo">
                  <strong>内容营销经理</strong>
                </div>
              </div>
            </div>

            <div class="testimonialCard">
              <div class="stars">★★★★★</div>
              <h3>"提升视频的说服力"</h3>
              <p>使用唇音驱动功能后，我发现视频中的虚拟角色说话非常自然，几乎可以以假乱真，这对于提升视频的说服力非常有帮助。</p>
              <div class="reviewer">
                <img :src="require('@/assets/images/avatars/avatar-05.Dmbw8z7l.jpg')" alt="数字营销经理" />
                <div class="reviewerInfo">
                  <strong>数字营销经理</strong>
                </div>
              </div>
            </div>

            <div class="testimonialCard">
              <div class="stars">★★★★★</div>
              <h3>"提升转化率"</h3>
              <p>产品内置的视频脚本和CTA，我们可以更便捷地引导观众采取行动，如访问网站或购买产品。</p>
              <div class="reviewer">
                <img :src="require('@/assets/images/avatars/avatar-06.BMGK9R1I.jpg')" alt="社群运营" />
                <div class="reviewerInfo">
                  <strong>社群运营</strong>
                </div>
              </div>
            </div>

            <div class="testimonialCard">
              <div class="stars">★★★★★</div>
              <h3>"多语言支持"</h3>
              <p>多语言支持让我们提供本土化视频内容，与全球用户建立联系，提高顾客参与度，实现销售目标的增长。</p>
              <div class="reviewer">
                <img :src="require('@/assets/images/avatars/avatar-08.C5aKY-jV.jpg')" alt="海外运营经理" />
                <div class="reviewerInfo">
                  <strong>海外运营经理</strong>
                </div>
              </div>
            </div>

            <div class="testimonialCard">
              <div class="stars">★★★★★</div>
              <h3>"社交媒体适配"</h3>
              <p>让我们能够快速生成符合不同平台特性的视频，无论是社交媒体上的短视频，还是网站上的详细介绍视频，都能够迅速抓住目标受众的注意力。</p>
              <div class="reviewer">
                <img :src="require('@/assets/images/avatars/avatar-12.CCo2_Vu9.jpg')" alt="社交媒体经理" />
                <div class="reviewerInfo">
                  <strong>社交媒体经理</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { handleStart } from '@/utils/navigation'

export default {
  name: 'Home',
  methods: {
    handleStart() {
      handleStart(this.$router, this.$store)
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #F9FAFB;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Hero Section */
.hero {
  padding: 120px 0 0px;
  background: linear-gradient(180deg, #F9FAFB 0%, rgba(249, 250, 251, 0) 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
  margin-bottom: 24px;
}

.subtitle {
  font-size: 18px;
  color: #6B7280;
  max-width: 600px;
  margin: 0 auto 40px;
}

.heroButtons {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 64px;
  align-items: center;
}

.heroImage {
  margin-top: 48px;
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 16px;
  overflow: hidden;
}

.heroImage video {
  width: 100%;
  height: auto;
  border-radius: 16px;
  object-fit: cover;
}

/* Brand Logos */
.brands {
  padding: 40px 0;
  overflow: hidden;
}

.brands .container {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.brandScroll {
  display: flex;
  animation: scroll 30s linear infinite;
  /* 鼠标悬停时暂停动画 */
  &:hover {
    animation-play-state: paused;
  }
}

.brandGrid {
  display: flex;
  gap: 48px;
  align-items: center;
  flex-shrink: 0;
  padding: 20px 0;
}

.brandGrid img {
  width: 100px;
  height: auto;
  object-fit: contain;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.brandGrid img:hover {
  opacity: 1;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 768px) {
  .brandGrid {
    gap: 24px;
  }
  
  .brandGrid img {
    width: 80px;
  }
}

.featureGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 64px;
}

.featureCard {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

.featureCard.reverse {
  direction: rtl;
}

.featureCard.reverse .featureContent {
  direction: ltr;
}

.featureImage {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.featureImage:hover {
  transform: translateY(-4px);
}

.featureImage img {
  width: 100%;
  height: auto;
}

.featureContent h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 24px;
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.featureContent p {
  font-size: 18px;
  color: #6B7280;
  margin-bottom: 32px;
}

/* Buttons */
.primaryButton {
  padding: 14px 32px;
  background: #6366F1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.primaryButton:hover {
  background: #4F46E5;
  transform: translateY(-1px);
}

.secondaryButton {
  padding: 14px 32px;
  background: white;
  color: #6B7280;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.secondaryButton:hover {
  background: #F9FAFB;
  border-color: #D1D5DB;
}

/* Testimonials Section */
.testimonials {
  padding: 120px 0;
  background: #F9FAFB;
}

.sectionTitle {
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 64px;
}

.testimonialGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.testimonialCard {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
}

.testimonialCard:hover {
  transform: translateY(-4px);
}

.stars {
  color: #F59E0B;
  font-size: 24px;
  margin-bottom: 16px;
}

.testimonialCard h3 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
}

.testimonialCard p {
  font-size: 16px;
  line-height: 1.6;
  color: #6B7280;
  margin-bottom: 24px;
}

.reviewer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reviewer img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.reviewerInfo strong {
  display: block;
  font-size: 14px;
  color: #111827;
}

@media (max-width: 1024px) {
  .testimonialGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .testimonialGrid {
    grid-template-columns: 1fr;
  }
  
  .testimonialCard {
    padding: 24px;
  }
}

.buttonGroup {
  display: flex;
  gap: 16px;
  align-items: center;
}

.advisorButton-wrapper {
  position: relative;
}

.advisorButton {
  padding: 14px 32px;
  background: white;
  color: #6366F1;
  border: 1px solid #6366F1;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.advisorButton:hover {
  background: #F9FAFB;
  border-color: #4F46E5;
  color: #4F46E5;
}

.qrcode-popup {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: none;
  text-align: center;
  z-index: 10;
}

.qrcode-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
}

.qrcode-popup img {
  border-radius: 8px;
  margin-bottom: 8px;
}

.qrcode-popup p {
  margin: 0;
  font-size: 14px;
  color: #6B7280;
}

.advisorButton-wrapper:hover .qrcode-popup {
  display: block;
}

@media (max-width: 768px) {
  .buttonGroup {
    flex-direction: column;
    gap: 12px;
  }
  
  .advisorButton {
    width: 100%;
  }
  
  .qrcode-popup {
    left: 0;
    transform: none;
    width: 100%;
  }
  
  .qrcode-popup::after {
    left: 50%;
  }
}
</style> 